import { GAMES } from "../../config/landingConfig";
import { scrollToId } from "../../lib/scroll";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

const CHIP_COLORS = ["bg-cyan text-ink", "bg-magenta text-white", "bg-violet text-white"];

export const GameGallery = () => {
  const go = (e) => {
    e.preventDefault();
    scrollToId("#pakiety");
  };

  return (
    <section data-testid="game-gallery-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
        <Reveal>
          <SectionTag number="05" label="Przykładowe gry" color="bg-cyan" />
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-3xl text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Tak wyglądają <span className="marker-cyan">gry z kursu</span>
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink/70 sm:text-lg">
            Kryminały, karty ról, debaty i gry interaktywne w przeglądarce
            - różne typy aktywności, jeden cel: uczniowie mówią.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {GAMES.map((game, i) => (
            <Reveal key={game.title} delay={(i % 3) * 0.1} className="h-full">
              <figure
                data-testid={`game-card-${i + 1}`}
                className={`hover-lift flex h-full flex-col overflow-hidden rounded-3xl border-2 border-ink bg-white shadow-hard ${
                  i % 2 === 0 ? "lg:-rotate-1" : "lg:rotate-1"
                }`}
              >
                <div className="aspect-[3/2] overflow-hidden border-b-2 border-ink">
                  <img
                    src={game.img}
                    alt={game.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-300 hover:scale-[1.03]"
                  />
                </div>
                <figcaption className="flex flex-1 flex-col gap-2 p-5">
                  <span
                    className={`inline-block w-fit rounded-full border-2 border-ink px-3 py-0.5 text-[11px] font-extrabold uppercase tracking-wide ${CHIP_COLORS[i % 3]}`}
                  >
                    {game.type}
                  </span>
                  <span className="font-display text-xl uppercase tracking-wide text-ink">
                    {game.title}
                  </span>
                  <span className="text-sm leading-relaxed text-ink/70">{game.desc}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}

          <Reveal delay={0.2} className="h-full sm:col-span-2 lg:col-span-3">
            <div
              data-testid="gallery-more-card"
              className="hover-lift flex h-full flex-col items-start gap-4 rounded-3xl border-2 border-ink bg-magenta p-7 shadow-hard sm:flex-row sm:items-center sm:justify-between sm:gap-8"
            >
              <div className="flex items-center gap-5">
                <p className="font-display shrink-0 text-4xl uppercase leading-none text-white sm:text-5xl">
                  +44
                </p>
                <p className="max-w-xl text-base font-bold leading-relaxed text-white/90">
                  kolejnych pomysłów czeka na Ciebie w kursie. Razem daje to 50 gier
                  i aktywności na speaking - wszystkie do stworzenia z AI.
                </p>
              </div>
              <a
                href="#pakiety"
                data-testid="gallery-more-cta"
                onClick={(e) => {
                  window.fbq?.("trackCustom", "ClickCTA", { location: "galeria-gier" });
                  go(e);
                }}
                className="hover-lift shrink-0 rounded-full border-2 border-ink bg-cyan px-6 py-3 text-sm font-extrabold text-ink shadow-hard-sm"
              >
                Zobacz pakiety
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
